module.exports = __webpack_public_path__ + "static/media/grad.eb5f367b.png";